import OverlayTips from "../OverlayTips";

function CompletedTasksPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

CompletedTasksPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle").first().find("span"), {
            messageKey: "tips.completed_tasks.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });

        this.add($(".formbuttonpane"), {
            messageKey: "tips.completed_tasks.filter",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetY: 5
        });

        this.add($(".listTableCompletionCell").eqOrLast(1), {
            messageKey: "tips.completed_tasks.check_date",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -30,
            offsetY: 5
        });

        this.add($(".listbuttonpane"), {
            messageKey: "tips.completed_tasks.buttons",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetY: -10
        });
    }
});

export default CompletedTasksPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/CompletedTasksPageOverlayTipsManager.js